export default __webpack_public_path__ + "static/media/img-result-a-big@3x.54e5dfeb.png";